export enum actionTypes {
  //FetchDcddUsers
  FETCH_DCDD_USERS_REQUEST = "FETCH_DCDD_USERS_REQUEST",
  FETCH_DCDD_USERS_SUCCESS = "FETCH_DCDD_USERS_SUCCESS",
  FETCH_DCDD_USERS_FAIL = "FETCH_DCDD_USERS_FAIL",
  //FetchDcddActiveUsers
  FETCH_DCDD_ACTIVE_USERS_REQUEST = "FETCH_DCDD_ACTIVE_USERS_REQUEST",
  FETCH_DCDD_ACTIVE_USERS_SUCCESS = "FETCH_DCDD_ACTIVE_USERS_SUCCESS",
  FETCH_DCDD_ACTIVE_USERS_FAIL = "FETCH_DCDD_ACTIVE_USERS_FAIL",
  //FetchDcddUsersBYdate Range
  FETCH_DCDD_USERS_BY_DATE_RANGE_REQUEST = "FETCH_DCDD_USERS_BY_DATE_RANGE_REQUEST",
  FETCH_DCDD_USERS_BY_DATE_RANGE_SUCCESS = "FETCH_DCDD_USERS_BY_DATE_RANGE_SUCCESS",
  FETCH_DCDD_USERS_BY_DATE_RANGE_FAIL = "FETCH_DCDD_USERS_BY_DATE_RANGE_FAIL",
  //FetchDcddUserProfileByUserID
  FETCH_DCDD_USER_PROFILE_BY_USER_ID_REQUEST = "FETCH_DCDD_USER_PROFILE_BY_USER_ID_REQUEST",
  FETCH_DCDD_USER_PROFILE_BY_USER_ID_SUCCESS = "FETCH_DCDD_USER_PROFILE_BY_USER_ID_SUCCESS",
  FETCH_DCDD_USER_PROFILE_BY_USER_ID_FAIL = "FETCH_DCDD_USER_PROFILE_BY_USER_ID_FAIL",
  //CreateDcddUser
  CREATE_DCDD_USER_REQUEST = "CREATE_DCDD_USER_REQUEST",
  CREATE_DCDD_USER_SUCCESS = "CREATE_DCDD_USER_SUCCESS",
  CREATE_DCDD_USER_FAIL = "CREATE_DCDD_USER_FAIL",
  //UpdateDcddUser
  UPDATE_DCDD_USER_PASSWORD_REQUEST = "UPDATE_DCDD_USER_PASSWORD_REQUEST",
  UPDATE_DCDD_USER_PASSWORD_SUCCESS = "UPDATE_DCDD_USER_PASSWORD_SUCCESS",
  UPDATE_DCDD_USER_PASSWORD_FAIL = "UPDATE_DCDD_USER_PASSWORD_FAIL",
  //UpdateDcddUserPassword
  UPDATE_DCDD_USER_REQUEST = "UPDATE_DCDD_USER_REQUEST",
  UPDATE_DCDD_USER_SUCCESS = "UPDATE_DCDD_USER_SUCCESS",
  UPDATE_DCDD_USER_FAIL = "UPDATE_DCDD_USER_FAIL",
  //UpdateDcddUserStatus
  UPDATE_DCDD_USER_STATUS_REQUEST = "UPDATE_DCDD_USER_STATUS_REQUEST",
  UPDATE_DCDD_USER_STATUS_SUCCESS = "UPDATE_DCDD_USER_STATUS_SUCCESS",
  UPDATE_DCDD_USER_STATUS_FAIL = "UPDATE_DCDD_USER_STATUS_FAIL",
  //registration
  BULK_REGISTRATION_REQUEST = "BULK_REGISTRATION_REQUEST",
  BULK_REGISTRATION_SUCCESS = "BULK_REGISTRATION_SUCCESS",
  BULK_REGISTRATION_FAIL = "BULK_REGISTRATION_FAIL",
  //CheckForExistingDcddUserByEmailSuccessAction
  CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_REQUEST = "CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_REQUEST",
  CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_SUCCESS = "CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_SUCCESS",
  CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_FAIL = "CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_FAIL",
  CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_REQUEST = "CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_REQUEST",
  CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_SUCCESS = "CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_SUCCESS",
  CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_FAIL = "CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_FAIL",
  RESET_DCDD_DETAILS = "RESET_DCDD_DETAILS",
  //fetch dzongkhag
  FETCH_DZONGKHAG_REQUEST = "FETCH_DZONGKHAG_REQUEST",
  FETCH_DZONGKHAG_SUCCESS = "FETCH_DZONGKHAG_SUCCESS",
  FETCH_DZONGKHAG_FAIL = "FETCH_DZONGKHAG_FAIL",
  //fetch SCHOOL
  FETCH_SCHOOLS_REQUEST = "FETCH_SCHOOLS_REQUEST",
  FETCH_SCHOOLS_SUCCESS = "FETCH_SCHOOLS_SUCCESS",
  FETCH_SCHOOLS_FAIL = "FETCH_SCHOOLS_FAIL",
  //fetch ECCD
  FETCH_ECCD_REQUEST = "FETCH_ECCD_REQUEST",
  FETCH_ECCD_SUCCESS = "FETCH_ECCD_SUCCESS",
  FETCH_ECCD_FAIL = "FETCH_ECCD_FAIL",
  //fetch GRADE
  FETCH_GRADES_REQUEST = "FETCH_GRADES_REQUEST",
  FETCH_GRADES_SUCCESS = "FETCH_GRADES_SUCCESS",
  FETCH_GRADES_FAIL = "FETCH_GRADES_FAIL",
}

export interface GenericProps {
  id:string;
  name:string
  sort?:string;
  pvt_public?:string;

}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface DcddUserProps {
  category: string;
  created_at: string;
  email: string;
  id: string;
  login_id: string;
  mobile_no: string;
  password: string;
  status: string;
  student_id: string;
  updated_at: string;
  user_identifier: string;
  user_profile:DcddUserProfileProps
}
export interface DcddUserProfileProps {
  cid: string;
  created_at: string;
  dob: string;
  dzongkhag_id: string;
  eccd_id: string;
  gender: string;
  grade_id: string;
  id: string;
  name: string;
  profile_picture: string;
  student_id: string;
  updated_at: string;
  dzongkhag:GenericProps
  school:GenericProps
  grade:GenericProps
  eccd:GenericProps  
}

export interface DcddUserActivityProps {
    id:string;
    year:string;
    user_id:string;
    month:string;
    total_count:string
    created_at:string;
    updated_at:string;
    user:DcddUserProps;
    activity_counts:ActivityCountProp
}

export interface RegisteredDcddUserProps {
  user_id:string;
  month:string;
  year:string;
  total_count:string;
  user: DcddUserProps;
  activity_counts:ActivityCountProp

}

export interface ActivityCountProp {
  video_watched:string;
  others:string;
  CheyChey:string;
}
export interface DcddFetchUserProps {
  category: string;
  cid: string;
  created_at: string;
  dob: string;
  dzongkhag_id: string;
  eccd_id: string;
  email: string;
  gender: string;
  grade_id: string;
  id: string;
  login_id: string;
  mobile_no: string;
  name: string;
  password: string;
  profile_picture: string;
  status: string;
  student_id: string;
  updated_at: string;
  user_identifier: string;
}
export interface DcddUserInput {
  student_id?: string;
  school_id?: string;
  cid?: string;
  dzongkhag_id: string;
  name: string;
  dob?: string;
  category: string;
  grade_id?: string;
  eccd_id?: string;
  email?: string;
  password?: string;
  gender: string;
  mobile_no?: string;
}
export interface DcddUserInputError {
  student_id?: string;
  school_id?: string;
  cid?: string;
  dzongkhag_id?: string;
  name?: string;
  dob?: string;
  category?: string;
  grade_id?: string;
  eccd_id?: string;
  email?: string;
  password?: string;
  gender?: string;
  mobile_no?: string;
}

export interface DateRangeInput {
  fromDate:string;
  toDate:string
}
export interface UpdatePasswordInput {
  password:string;
}
export interface DateRangeInputError {
  fromDate?:string;
  toDate?:string;
  category?:string;
  dzongkhag_id?:string;
}
//FetchDcddUsers
export interface FetchDcddUsersRequestAction {
  type: actionTypes.FETCH_DCDD_USERS_REQUEST;
}

export interface FetchDcddUsersSuccessAction {
  type: actionTypes.FETCH_DCDD_USERS_SUCCESS;
  payload: DcddUserProps[];
}

export interface FetchDcddUsersFailureAction {
  type: actionTypes.FETCH_DCDD_USERS_FAIL;
  payload: string;
}
//FetchDcddActiveUsers
export interface FetchDcddActiveUsersRequestAction {
  type: actionTypes.FETCH_DCDD_ACTIVE_USERS_REQUEST;
}

export interface FetchDcddActiveUsersSuccessAction {
  type: actionTypes.FETCH_DCDD_ACTIVE_USERS_SUCCESS;
  payload: DcddFetchUserProps[];
}

export interface FetchDcddActiveUsersFailureAction {
  type: actionTypes.FETCH_DCDD_ACTIVE_USERS_FAIL;
  payload: string;
}
//FetchDcddUsersByDateRange
export interface FetchDcddUsersByDateRangeRequestAction {
  type: actionTypes.FETCH_DCDD_USERS_BY_DATE_RANGE_REQUEST;
}

export interface FetchDcddUsersByDateRangeSuccessAction {
  type: actionTypes.FETCH_DCDD_USERS_BY_DATE_RANGE_SUCCESS;
  payload: DcddFetchUserProps[];
}

export interface FetchDcddUsersByDateRangeFailureAction {
  type: actionTypes.FETCH_DCDD_USERS_BY_DATE_RANGE_FAIL;
  payload: string;
}
//FetchDcddUsersprofileBYuserID
export interface FetchDcddUserProfileByUserIdRequestAction {
  type: actionTypes.FETCH_DCDD_USER_PROFILE_BY_USER_ID_REQUEST;
}

export interface FetchDcddUserProfileByUserIdSuccessAction {
  type: actionTypes.FETCH_DCDD_USER_PROFILE_BY_USER_ID_SUCCESS;
  payload: RegisteredDcddUserProps[];
}

export interface FetchDcddUserProfileByUserIdFailureAction {
  type: actionTypes.FETCH_DCDD_USER_PROFILE_BY_USER_ID_FAIL;
  payload: string;
}
//CreateDcddUser
export interface CreateDcddUserRequestAction {
  type: actionTypes.CREATE_DCDD_USER_REQUEST;
}
export interface CreateDcddUserSuccessAction {
  type: actionTypes.CREATE_DCDD_USER_SUCCESS;
  payload: RegisteredDcddUserProps;
}
export interface CreateDcddUserFailAction {
  type: actionTypes.CREATE_DCDD_USER_FAIL;
  payload: string;
}
//UpdateDcddUser
export interface UpdateDcddUserRequestAction {
  type: actionTypes.UPDATE_DCDD_USER_REQUEST;
}
export interface UpdateDcddUserSuccessAction {
  type: actionTypes.UPDATE_DCDD_USER_SUCCESS;
  payload: RegisteredDcddUserProps;
}
export interface UpdateDcddUserFailAction {
  type: actionTypes.UPDATE_DCDD_USER_FAIL;
  payload: string;
}
//UpdateDcddUserPasword
export interface UpdateDcddUserPasswordRequestAction {
  type: actionTypes.UPDATE_DCDD_USER_PASSWORD_REQUEST;
}
export interface UpdateDcddUserPasswordSuccessAction {
  type: actionTypes.UPDATE_DCDD_USER_PASSWORD_SUCCESS;
  payload: RegisteredDcddUserProps;
}
export interface UpdateDcddUserPasswordFailAction {
  type: actionTypes.UPDATE_DCDD_USER_PASSWORD_FAIL;
  payload: string;
}
//UpdateDcddUserStatus
export interface UpdateDcddUserStatusRequestAction {
  type: actionTypes.UPDATE_DCDD_USER_STATUS_REQUEST;
}
export interface UpdateDcddUserStatusSuccessAction {
  type: actionTypes.UPDATE_DCDD_USER_STATUS_SUCCESS;
  payload: DcddUserProps;
}
export interface UpdateDcddUserStatusFailAction {
  type: actionTypes.UPDATE_DCDD_USER_STATUS_FAIL;
  payload: string;
}
//BulkRegistration
export interface BulkRegistrationRequestAction {
  type: actionTypes.BULK_REGISTRATION_REQUEST;
}
export interface BulkRegistrationSuccessAction {
  type: actionTypes.BULK_REGISTRATION_SUCCESS;
  payload: string;
}
export interface BulkRegistrationFailAction {
  type: actionTypes.BULK_REGISTRATION_FAIL;
  payload: string;
}
//CheckForExistingDcddUserByMobile
export interface CheckForExistingDcddUserByMobileRequestAction {
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_REQUEST;
}
export interface CheckForExistingDcddUserByMobileSuccessAction {
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_SUCCESS;
}

export interface CheckForExistingDcddUserByMobileFailAction {
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_MOBILE_FAIL;
  payload: string;
}

//CheckForExistingDcddUserByEmail
export interface CheckForExistingDcddUserByEmailRequestAction {
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_REQUEST;
}
export interface CheckForExistingDcddUserByEmailSuccessAction {
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_SUCCESS;
}

export interface CheckForExistingDcddUserByEmailFailAction {
  type: actionTypes.CHECK_FOR_EXISTING_DCDD_USER_BY_EMAIL_FAIL;
  payload: string;
}

export interface ResetDcddDetails {
  type: actionTypes.RESET_DCDD_DETAILS;
}

//Fetch dzongkhag
export interface FetchDzongkhagRequestAction {
  type: actionTypes.FETCH_DZONGKHAG_REQUEST;
}

export interface FetchDzongkhagSuccessAction {
  type: actionTypes.FETCH_DZONGKHAG_SUCCESS;
  payload: GenericProps[];
}

export interface FetchDzongkhagFailureAction {
  type: actionTypes.FETCH_DZONGKHAG_FAIL;
  payload: string;
}
//Fetch school
export interface FetchSchoolsRequestAction {
  type: actionTypes.FETCH_SCHOOLS_REQUEST;
}

export interface FetchSchoolsSuccessAction {
  type: actionTypes.FETCH_SCHOOLS_SUCCESS;
  payload: GenericProps[];
}

export interface FetchSchoolsFailureAction {
  type: actionTypes.FETCH_SCHOOLS_FAIL;
  payload: string;
}
//Fetch ecdd
export interface FetchEccdRequestAction {
  type: actionTypes.FETCH_ECCD_REQUEST;
}

export interface FetchEccdSuccessAction {
  type: actionTypes.FETCH_ECCD_SUCCESS;
  payload: GenericProps[];
}

export interface FetchEccdFailureAction {
  type: actionTypes.FETCH_ECCD_FAIL;
  payload: string;
}
//Fetch grades
export interface FetchGradesRequestAction {
  type: actionTypes.FETCH_GRADES_REQUEST;
}

export interface FetchGradesSuccessAction {
  type: actionTypes.FETCH_GRADES_SUCCESS;
  payload: GenericProps[];
}

export interface FetchGradesFailureAction {
  type: actionTypes.FETCH_GRADES_FAIL;
  payload: string;
}
export type DcddUserActions =
  | FetchDcddUsersRequestAction
  | FetchDcddUsersSuccessAction
  | FetchDcddUsersFailureAction
  | FetchDcddActiveUsersRequestAction
  | FetchDcddActiveUsersSuccessAction
  | FetchDcddActiveUsersFailureAction
  | FetchDcddUsersByDateRangeRequestAction
  | FetchDcddUsersByDateRangeSuccessAction
  | FetchDcddUsersByDateRangeFailureAction
  | FetchDcddUserProfileByUserIdRequestAction
  | FetchDcddUserProfileByUserIdSuccessAction
  | FetchDcddUserProfileByUserIdFailureAction
  | CreateDcddUserRequestAction
  | CreateDcddUserSuccessAction
  | CreateDcddUserFailAction
  | UpdateDcddUserRequestAction
  | UpdateDcddUserSuccessAction
  | UpdateDcddUserFailAction
  | UpdateDcddUserPasswordRequestAction
  | UpdateDcddUserPasswordSuccessAction
  | UpdateDcddUserPasswordFailAction
  | UpdateDcddUserStatusRequestAction
  | UpdateDcddUserStatusSuccessAction
  | UpdateDcddUserStatusFailAction
  | BulkRegistrationRequestAction
  | BulkRegistrationSuccessAction
  | BulkRegistrationFailAction
  | CheckForExistingDcddUserByMobileRequestAction
  | CheckForExistingDcddUserByMobileSuccessAction
  | CheckForExistingDcddUserByMobileFailAction
  | CheckForExistingDcddUserByEmailRequestAction
  | CheckForExistingDcddUserByEmailSuccessAction
  | CheckForExistingDcddUserByEmailFailAction
  | ResetDcddDetails
  | FetchDzongkhagRequestAction
  | FetchDzongkhagSuccessAction
  | FetchDzongkhagFailureAction
  | FetchSchoolsRequestAction
  | FetchSchoolsSuccessAction
  | FetchSchoolsFailureAction
  | FetchEccdRequestAction
  | FetchEccdSuccessAction
  | FetchEccdFailureAction
  | FetchGradesRequestAction
  | FetchGradesSuccessAction
  | FetchGradesFailureAction
